import * as React from 'react'
import { IServiceObject, IServiceOptions, IStoreState } from '../../../types/index'
import ServiceDefaultLogo from '../../icons/ui/ServiceDefaultLogo'
import PreloaderCircle from '../../ui/PreloaderCircle'
import { IServiceProgramObject } from '../../../types/service-program'
import Error from '../../membership-request/Error'
import ErrorMessage from '../../ui/ErrorMessage'
import ImageView from '../../ui/ImageView'
import UIMessages from 'src/utils/ui-messages'
import { ServiceOptionDisplay, viewOptionTypes } from 'src/constants/service'
import { Link } from 'react-router-dom'
interface IServiceViewMainInfoProps {
  serviceId: string
  service?: IServiceObject
  serviceProgram?: IServiceProgramObject
  fetching: boolean
  fetchingError: string
}
// const serviceId =
//   process.env.REACT_APP_ENV === 'production'
//     ? 'd343b302-1e9d-4031-83b5-0706ebe2a9ac'
//     : 'e5bc445a-1347-455b-a677-52f44c0a3e76'

const showGenerateButton = process.env.REACT_APP_ENV === 'production' ? false : true
class ServiceViewMainInfo extends React.Component<IServiceViewMainInfoProps, IStoreState> {
  constructor(props: IServiceViewMainInfoProps) {
    super(props)
  }

  public render() {
    const { serviceProgram, service } = this.props

    const serviceName = service ? service.name : ''
    const serviceId = service ? service.id : ''

    return (
      <>
        {this.props.fetching && (
          <div className='flex justify-center pt3'>
            <PreloaderCircle loading={true} />
          </div>
        )}

        <ErrorMessage visible={!!this.props.fetchingError}>{this.props.fetchingError}</ErrorMessage>

        {service && (
          <div className='ml3'>
            <div className='h4 mt3 bold font-dark-grey'>{UIMessages.service.serviceInfo}</div>
            <div className='mt2 flex items-center'>
              <ImageView name={service.name} entityId={service.id} />
              <div className='ml2'>
                <div className='h3 bold font-dark-grey'>{service.name}</div>
                <div className='h5 font-grey3'>{serviceProgram && serviceProgram.name}</div>
              </div>
              &nbsp; &nbsp; &nbsp;
              {serviceName.toLowerCase().includes('access2care') && serviceId !== '' && (
                <div>
                  &nbsp; &nbsp; &nbsp;
                  <Link
                    className='SubmitButton btn bg-green rounded font-white weight-300'
                    to={`/services/${serviceId}/access2care`}
                  >
                    Generate Access2Care report
                  </Link>
                </div>
              )}
              {serviceName.toLowerCase().includes('modivcare') && serviceId !== '' && (
                <div>
                  &nbsp; &nbsp; &nbsp;
                  <Link
                    className='SubmitButton btn bg-green rounded font-white weight-300'
                    to={`/services/${serviceId}/modivcare`}
                  >
                    Generate Modivcare report
                  </Link>
                </div>
              )}
              &nbsp; &nbsp; &nbsp;
              <Link
                className='SubmitButton btn bg-green rounded font-white weight-300'
                to={`/services/${serviceId}/afterhoursreport`}
              >
                Generate After Hours Report
              </Link>
            </div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.internalName}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.internalName}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.serviceDes}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.description}</div>
            {/* PHONE NUMBER */}
            <div className='h6 font-grey3 mt3'>{UIMessages.service.phoneNumber}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.phoneNumber}</div>

            <div className='h6 font-grey3 mt3'>{UIMessages.service.membershipReq}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.isMembershipRequired ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.viewOption}</div>
            <div className='mt1 h5 font-dark-grey col-4'>
              {service.viewOption === viewOptionTypes.public
                ? UIMessages.service.publicService
                : UIMessages.service.privateService}
            </div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.tripLimit}</div>
            <div className='mt1 h5 font-dark-grey col-4'>
              {service.tripLimit ? `${service.tripLimit} trips per ${service.tripLimitDuration}` : 'No Limit'}
            </div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.groupRide}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.isGroupRide ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.autoDispatch}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.autoDispatch ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.multipleStop}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.allowMultipleStop ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.signatureCollection}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.signatureCollectionRequired ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.serviceOptions}</div>
            <div className='mt1 h5 font-dark-grey col-4'>
              {service.serviceOptions && service.serviceOptions.length > 0
                ? service.serviceOptions.map(s => ServiceOptionDisplay[IServiceOptions[s]]).join(', ')
                : 'None'}
            </div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.notificationMessage}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.notificationMessage || '--'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.onDemandTripReminder}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.onDemandTripReminder ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.scheduledTripReminder}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.scheduledTripReminder ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.willCallTripReminder}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.willCallTripReminder ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.requestTimeoutDuration}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.requestTimeoutDuration || 0}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.maxTravelDistance}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.maxTravelDistance || 0}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.allowMobileRequest}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.allowMobileRequest ? 'Yes' : 'No'}</div>
            <div className='h6 font-grey3 mt3'>{UIMessages.service.rideReconfirmation}</div>
            <div className='mt1 h5 font-dark-grey col-4'>{service.rideReconfirmation || 0}</div>
          </div>
        )}
      </>
    )
  }
}

export default ServiceViewMainInfo



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewMainInfo.tsx